import React from 'react';

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { Warning } from '@material-ui/icons';

import DialogWrapper from './dialog-wrapper';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: theme.palette.error.main,
    padding: 10,
    display: 'flex',
    justifyContent: 'center',
  },
  dialogTitleText: {
    color: theme.palette.primary.contrastText,
    display: 'flex',
    alignItems: 'center',
  },
  content: {
    padding: 20,
  },
}));

type ErrorMessageDialogProps = {
  isModalOpen: boolean;
  handleModalClose: () => void;
  message: string;
};

const ErrorMessageDialog = ({
  isModalOpen,
  handleModalClose,
  message,
}: ErrorMessageDialogProps) => {
  const classes = useStyles();

  if (!message) {
    return null;
  }

  return (
    <div>
      <DialogWrapper open={isModalOpen} onClose={handleModalClose}>
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <Typography
            className={classes.dialogTitleText}
            color='textSecondary'
            variant='h5'
          >
            <Warning />
            Fel
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText className={classes.content}>
            <Typography component='span' align='center' variant='body2'>
              <strong> {message}</strong>
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose}>OK</Button>
        </DialogActions>
      </DialogWrapper>
    </div>
  );
};

export default ErrorMessageDialog;
